module.exports = __webpack_public_path__ + "static/img/eventos-especiales.5bfa9bea.jpeg";